"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const material_kit_pro_react_1 = require("../assets/jss/material-kit-pro-react");
const config_1 = require("../config/config");
const styles = (theme) => (0, styles_1.createStyles)({
    container: material_kit_pro_react_1.container,
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: config_1.config.themeColors.warningBackgroundColor.hex(),
        maxWidth: '295px',
        minHeight: 'auto',
        borderRadius: 8,
        padding: '4px 8px 4px 16px',
        gap: '12px',
        [theme.breakpoints.down('xs')]: {
            minWidth: '100%'
        }
    },
    title: {
        marginTop: theme.spacing(2)
    },
    detailContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
        cursor: 'pointer'
    },
    signInIcon: {
        width: '24px',
        height: '24px'
    }
});
exports.default = styles;
//# sourceMappingURL=SignInWarningStyle.js.map